import { defineMessages } from 'react-intl';

export default defineMessages({
    FirstName: {
        id: 'tfpa.quoteandbind.views.additionalInsured.First Name',
        defaultMessage: 'First Name',
    },
    LastName: {
        id: 'tfpa.quoteandbind.views.additionalInsured.Last Name',
        defaultMessage: 'Last Name',
    },
    saveFailedMsg: {
        id: 'tfpa.quoteandbind.views.additionalInsured.Save failed, please try again',
        defaultMessage: 'Save failed, please try again',
    },
    saveFailedTitle: {
        id: 'tfpa.quoteandbind.views.additionalInsured.Can\'t Modify Contact',
        defaultMessage: 'Can\'t Modify Contact',
    },
    // DE16336
    ageValidationError: {
        id: "tfpa.quoteandbind.views.additionalInsured.ageValidationError",
        defaultMessage: "Age must not be less than 16 years or greater than 120 years."
    },

});
